<script setup lang="ts">
import { useFilterStore } from '@Portal/stores/filter';
import { storeToRefs } from 'pinia';
import { getImageUrl } from '../utility';
defineProps<{
  hasNoData?: boolean;
}>();

const filterStore = useFilterStore();
const { dateFilterDisplayValue } = storeToRefs(filterStore);
</script>
<template>
  <div
    class="stretch-height skeleton flex"
    :style="`background: url(${getImageUrl('/social/ReviewsGeneratedBackground_Skeleton.svg')}); background-position: right; background-size: cover;`"
    v-if="!hasNoData"
  >
    <!-- pr-301px here is to give the div width equal to the width of its absolute positioned children so that mx-auto will properly centre it -->
    <div class="mt-150px mx-auto pl-4 pr-301px relative">
      <div class="animate absolute bg-[#e0e0e0] h-64px w-71px rounded-1"></div>
      <div class="absolute left-103px flex flex-col inline-block h-64px justify-around">
        <div class="animate bg-[#e0e0e0] h-16px w-140px rounded-1"></div>
        <div class="animate bg-[#e0e0e0] h-16px w-198px rounded-1"></div>
      </div>
    </div>
  </div>
  <!-- Non-skeleton styling for when there is no data -->
  <div
    class="stretch-height flex flex-col"
    :style="`background: url(${getImageUrl('/social/ReviewsGeneratedBackground.svg')}); background-position: center; background-size: cover;`"
    v-else
  >
    <p class="visual-title">Updates {{ dateFilterDisplayValue }}</p>
    <div class="mx-auto my-auto mt-150px flex gap-12px items-center">
      <div class="bg-[#c73362] rounded d-block p-0 px-3 text-white font-bold text-48px line-height-60px">-</div>
      <p id="ReviewsGeneratedTagline" class="m-0 text-18px max-w-[210px] font-semibold line-height-24px">
        Reviews Generated from Review Amplifier
      </p>
    </div>
  </div>
</template>
